"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.platform = exports.getPlatform = void 0;
var getPlatform = function () {
    var platform = 'web';
    if (typeof document !== 'undefined') {
        platform = 'web';
    }
    else if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
        platform = 'react-native';
    }
    else {
        // nodejs
        platform = 'web';
    }
    return platform;
};
exports.getPlatform = getPlatform;
exports.platform = exports.getPlatform();
